export const REGEX_PIN = /^[0-9]{0,4}$/;
export const REGEX_PIN_VALIDATION = /[0-9]{4}/;
export const REGEX_PIN_SEARCH_PATTERN = /[0-9]{1,4}/;
export const CARACTERE_ONLY = /^[a-zA-ZâêûîäëöüïßÄÖÜÄÂËÊÜÛÎÏù éèàÉÀÇÈ0-9-'_:!?,.&()\\/{[}\]"#ç^¨ù]*$/;
